import { TFunction } from 'i18next'

import { ErrorName, StoreError } from './types'

export function titleForError(error?: StoreError, t?: TFunction) {
  switch (error?.name) {
    case ErrorName.BLUETOOTH_OFF:
      return t
        ? t('Phone bluetooth is switched off. Please turn it on and try again.')
        : 'Phone bluetooth is switched off. Please turn it on and try again.'
    case ErrorName.BLUETOOTH_DENIED:
      return t
        ? t('Access to bluetooth is not granted. Please allow access to bluetooth and try again.')
        : 'Access to bluetooth is not granted. Please allow access to bluetooth and try again.'
    case ErrorName.LOCATION_DENIED:
      return t
        ? t('Access to location services is not granted. Please turn location services on and try again.')
        : 'Access to location services is not granted. Please turn location services on and try again.'
    case ErrorName.STARTING_FAILED:
      return t
        ? t('Something went wrong while starting up bluetooth. Please try again.')
        : 'Something went wrong while starting up bluetooth. Please try again.'
    case ErrorName.CHARGING_FAILED:
      return t
        ? t('Phone did not start charging. Did you place the phone correctly on the charger?')
        : 'Phone did not start charging. Did you place the phone correctly on the charger?'
    case ErrorName.SCANNING_FAILED:
      return t ? t('No chargers were found. Please try again.') : 'No chargers were found. Please try again.'
    case ErrorName.RANGING_FAILED:
      return error.info?.found
        ? t
          ? t('Invalid charger beacon found. Verify that the selected device is correct and try again.')
          : 'Invalid charger beacon found. Verify that the selected device is correct and try again.'
        : t
          ? t('The charger beacon was not found. Please try again.')
          : 'The charger beacon was not found. Please try again.'
    case ErrorName.CONNECTING_FAILED:
      return t
        ? t('Connection to the charger failed. Please try again.')
        : 'Connection to the charger failed. Please try again.'
    case ErrorName.READING_FAILED:
      return t
        ? t('Something went wrong reading the charger data. Please try again.')
        : 'Something went wrong reading the charger data. Please try again.'
    case ErrorName.WRITING_FAILED:
      return t
        ? t('Something went wrong writing the charger data. Please try again.')
        : 'Something went wrong writing the charger data. Please try again.'
    case ErrorName.FIRMWARE_FAILED:
      return t
        ? t('Something went wrong updating the firmware. Please try again.')
        : 'Something went wrong updating the firmware. Please try again.'
    case ErrorName.CHARACTERISTICS_FAILED:
      return t
        ? t('The received charger data is incorrect. Please try again.')
        : 'The received charger data is incorrect. Please try again.'
    case ErrorName.NETWORK_FAILED:
      return t
        ? t('The charger is not attached to the network. Please try again.')
        : 'The charger is not attached to the network. Please try again.'
    case ErrorName.SENSOR_FAILED:
      return t
        ? t('The charger sensor is not connected. Verify the sensor cable connection and try again.')
        : 'The charger sensor is not connected. Verify the sensor cable connection and try again.'
    case ErrorName.VALIDATION_FAILED:
      return t
        ? t(
            'The charger found does not match the tested device. Verify that the selected device is correct and try again.',
          )
        : 'The charger found does not match the tested device. Verify that the selected device is correct and try again.'
    default:
      return t ? t('An unknown error occurred. Please try again.') : 'An unknown error occurred. Please try again.'
  }
}
